module.exports = __webpack_public_path__ + "img/canbadge_hachikaku_58mm_trimmark.2ffebe5b.png";